import { forwardRef, useEffect, useState } from 'react';

import { cn } from '@/lib/utils';

const Input = forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, placeholder, value, onChange, ...props }, ref) => {
    const [hasValue, setHasValue] = useState(false);

    useEffect(() => {
      setHasValue(!!value);
    }, [value]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      setHasValue(e.target.value !== '');
      if (onChange) {
        onChange(e);
      }
    };

    return (
      <div className="relative z-10">
        <input
          type={type}
          className={cn(
            'peer relative z-10 flex h-[3rem] w-full rounded-md border border-gray-200 bg-transparent',
            'px-5 py-3.5 text-base file:border-0 file:bg-transparent file:text-sm file:font-medium',
            'placeholder:text-sm placeholder:text-transparent focus-visible:outline-none',
            'hover:border-primary hover:shadow-[0px_0px_5px_2px_#00000040] md:px-3.5 md:py-2 md:text-sm lg:text-base',
            'transition-color disabled:cursor-not-allowed disabled:hover:border-gray-200 disabled:hover:shadow-none',
            className,
          )}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          onBlur={handleChange}
          ref={ref}
          {...props}
        />
        {!hasValue ? (
          <label
            className={cn(
              'absolute left-5 top-5 -z-10 text-gray-200 transition-all duration-200 sm:left-4 sm:top-3',
              'origin-left peer-focus:-translate-y-[0.875rem] peer-focus:scale-x-[0.70] peer-focus:scale-y-[0.70] peer-focus:text-primary',
              'origin-left peer-hover:-translate-y-[0.875rem] peer-hover:scale-x-[0.70] peer-hover:scale-y-[0.70] peer-hover:text-primary',
            )}
          >
            {placeholder}
          </label>
        ) : null}
      </div>
    );
  },
);
Input.displayName = 'Input';

export { Input };
